import { render, staticRenderFns } from "./CatalogCourse.vue?vue&type=template&id=d2d368ea&scoped=true&"
import script from "./CatalogCourse.vue?vue&type=script&lang=js&"
export * from "./CatalogCourse.vue?vue&type=script&lang=js&"
import style0 from "./CatalogCourse.vue?vue&type=style&index=0&id=d2d368ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d368ea",
  null
  
)

export default component.exports